const HRM_TOKEN_KEY = 'hrm_api_token';

function pickTokenFromBody(body: unknown): string | null {
    if (!body || typeof body !== 'object') return null;
    const o = body as Record<string, unknown>;
    const direct =
        (typeof o.token === 'string' && o.token) ||
        (typeof o.access_token === 'string' && o.access_token) ||
        (typeof o.plainTextToken === 'string' && o.plainTextToken);
    if (direct) return direct;
    const data = o.data;
    if (data && typeof data === 'object') {
        const d = data as Record<string, unknown>;
        return (
            (typeof d.token === 'string' && d.token) ||
            (typeof d.access_token === 'string' && d.access_token) ||
            (typeof d.plainTextToken === 'string' && d.plainTextToken) ||
            null
        );
    }
    return null;
}

/** Call after successful `POST .../register` for HRM so branch-create can send Bearer token. */
export function persistHrmAuthFromRegisterResponse(body: unknown): boolean {
    const token = pickTokenFromBody(body);
    if (!token) return false;
    try {
        sessionStorage.setItem(HRM_TOKEN_KEY, token);
    } catch {
        return false;
    }
    return true;
}

export function getHrmApiToken(): string | null {
    try {
        return sessionStorage.getItem(HRM_TOKEN_KEY);
    } catch {
        return null;
    }
}

export function clearHrmApiToken(): void {
    try {
        sessionStorage.removeItem(HRM_TOKEN_KEY);
    } catch {
        /* ignore */
    }
}
